import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { sezioneCodiciRUI, useFormIscrizione } from "../FormContext";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { apiComuni } from "../utils/registerAPI";

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const Societa = ({ tipologiaAzienda, province, toponomie, errors }) => {
  const { formState, dispatch } = useFormIscrizione();
  const [comuniAzienda, setComuniAzienda] = useState([]);
  const [capAzienda, setCapAzienda] = useState([]);
  const [comuniResponsabile, setComuniResponsabile] = useState([]);
  const [capResponsabile, setCapResponsabile] = useState([]);

  console.log(capResponsabile);
  const handleComuni = (provinciaSigla, dati) => {
    if (dati === "azienda") {
      apiComuni(provinciaSigla).then((response) =>
        setComuniAzienda(response.data[0])
      );
    } else {
      apiComuni(provinciaSigla).then((response) =>
        setComuniResponsabile(response.data[0])
      );
    }
  };

  const handleCap = (comuneCodice, dati) => {
    if (dati === "azienda") {
      comuniAzienda.map((el) => {
        if (el.codice === comuneCodice) {
          setCapAzienda(el.cap);
          if (el.cap.length === 1) {
            dispatch({
              type: "set_datiAzienda",
              payload: {
                cap: el.cap[0],
              },
            });
          }
        }
      });
    } else {
      console.log("responsabile");
      comuniResponsabile.map((el) => {
        if (el.codice === comuneCodice) {
          setCapResponsabile(el.cap);
          if (el.cap.length === 1) {
            dispatch({
              type: "set_datiResponsabile",
              payload: {
                cap: el.cap[0],
              },
            });
          }
        }
      });
    }
  };

  return (
    <>
      <Card variant="outlined">
        <CardContent>
          <Box>
            <Typography component="h1" variant="h6" gutterBottom mb={4}>
              Dati Azienda
            </Typography>
            <Grid container spacing={3} wrap="wrap">
              <Grid item sm={3} xs={12}>
                <FormControl
                  size="small"
                  required
                  fullWidth
                  margin="none"
                  error={Boolean(errors.datiAzienda.tipologiaAzienda)}
                >
                  <InputLabel id="tipologiaAzienda-label">
                    Tipologia Azienda
                  </InputLabel>
                  <Select
                    labelId="tipologiaAzienda-label"
                    id="tipologiaAzienda"
                    name="tipologiaAzienda"
                    label="Tipologia Azienda"
                    value={formState.datiAzienda.tipologiaAzienda}
                    MenuProps={MenuProps}
                    onChange={(e) => {
                      dispatch({
                        type: "set_datiAzienda",
                        payload: {
                          tipologiaAzienda: e.target.value,
                        },
                      });
                    }}
                  >
                    <MenuItem value={0}></MenuItem>
                    {tipologiaAzienda.map((tipologia) => (
                      <MenuItem key={tipologia.id} value={tipologia.id}>
                        {tipologia.descrizioneAzienda} {tipologia.tipoAzienda}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.datiAzienda.tipologiaAzienda && (
                    <FormHelperText>
                      {errors.datiAzienda.tipologiaAzienda}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Ragione Sociale"
                  fullWidth
                  value={formState.datiAzienda.ragioneSociale}
                  id="ragioneSociale-Societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        ragioneSociale: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiAzienda.ragioneSociale)}
                  helperText={errors.datiAzienda.ragioneSociale}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="P. IVA"
                  fullWidth
                  value={formState.datiAzienda.pIva}
                  id="piva-Societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        pIva: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiAzienda.pIva)}
                  helperText={errors.datiAzienda.pIva}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={province}
                  getOptionLabel={(option) => option.nome}
                  value={
                    province.find(
                      (p) => p.sigla === formState.datiAzienda.provincia
                    ) || null
                  }
                  onChange={(_, newValue) => {
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        provincia: newValue ? newValue.sigla : "",
                        comune: "",
                        cap: "",
                      },
                    });
                    if (newValue) handleComuni(newValue.sigla, "azienda");
                  }}
                  renderInput={(params) => (
                    <TextField
                      id="provinciaAzienda"
                      name="provinciaAzienda"
                      error={Boolean(errors.datiAzienda.provincia)}
                      helperText={errors.datiAzienda.provincia}
                      {...params}
                      label="Provincia"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={comuniAzienda}
                  getOptionLabel={(option) => option.comune}
                  value={
                    comuniAzienda.find(
                      (c) => c.codice === formState.datiAzienda.comune
                    ) || null
                  }
                  onChange={(_, newValue) => {
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        comune: newValue ? newValue.codice : "",
                        cap: "",
                      },
                    });
                    if (newValue) handleCap(newValue.codice, "azienda");
                  }}
                  renderInput={(params) => (
                    <TextField
                      id="comuneAzienda"
                      name="comuneAzienda"
                      error={Boolean(errors.datiAzienda.comune)}
                      helperText={errors.datiAzienda.comune}
                      {...params}
                      label="Comune"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <FormControl
                  size="small"
                  required
                  fullWidth
                  margin="none"
                  error={Boolean(errors.datiAzienda.cap)}
                >
                  <InputLabel id="capAzienda-label">CAP</InputLabel>
                  <Select
                    labelId="capAzienda-label"
                    id="capAzienda"
                    name="capAzienda"
                    label="CAP"
                    value={formState.datiAzienda.cap}
                    MenuProps={MenuProps}
                    onChange={(e) => {
                      dispatch({
                        type: "set_datiAzienda",
                        payload: {
                          cap: e.target.value,
                        },
                      });
                    }}
                  >
                    {capAzienda.map((el, i) => (
                      <MenuItem key={i} value={el}>
                        {el}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.datiAzienda.cap && (
                    <FormHelperText>{errors.datiAzienda.cap}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item sm={3} xs={12}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={toponomie}
                  getOptionLabel={(option) => option.name}
                  value={
                    toponomie.find(
                      (t) => t.value === formState.datiAzienda.viacorso
                    ) || null
                  }
                  onChange={(_, newValue) => {
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        viacorso: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(errors.datiAzienda.viacorso)}
                      helperText={errors.datiAzienda.viacorso}
                      label="Via, Corso"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Indirizzo"
                  fullWidth
                  value={formState.datiAzienda.indirizzo}
                  id="indirizzo-Societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        indirizzo: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiAzienda.indirizzo)}
                  helperText={errors.datiAzienda.indirizzo}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Civico"
                  fullWidth
                  value={formState.datiAzienda.civico}
                  id="civico-Societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        civico: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiAzienda.civico)}
                  helperText={errors.datiAzienda.civico}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Telefono"
                  fullWidth
                  value={formState.datiAzienda.telefono}
                  id="telefono-Societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        telefono: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Fax"
                  fullWidth
                  value={formState.datiAzienda.fax}
                  id="fax-Societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        fax: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="E-mail"
                  fullWidth
                  value={formState.datiAzienda.email}
                  id="email-Societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        email: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiAzienda.email)}
                  helperText={errors.datiAzienda.email}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="PEC"
                  fullWidth
                  value={formState.datiAzienda.pec}
                  id="pec-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiAzienda",
                      payload: {
                        pec: e.target.value,
                      },
                    })
                  }
                />
              </Grid>
            </Grid>
          </Box>
          <Box mt={8}>
            <Typography component="h1" variant="h6" gutterBottom mb={4}>
              Ivass RUI Azienda
            </Typography>
            <Grid container spacing={3} wrap="wrap">
              <Grid item sm={3} xs={12}>
                <FormControl
                  size="small"
                  fullWidth
                  margin="none"
                  required
                  error={Boolean(errors.datiAzienda.sezioneRUI)}
                >
                  <InputLabel id="sezioneRUI-Societa-label">
                    Sezione Codice RUI
                  </InputLabel>
                  <Select
                    labelId="sezioneRUI-Societa-label"
                    id="sezioneRUI-Societa"
                    name="sezioneRUI-Societa"
                    label="Sezione Codice RUI"
                    value={formState.datiAzienda.ivassRUI.sezioneRUI}
                    MenuProps={MenuProps}
                    onChange={(e) => {
                      dispatch({
                        type: "set_ivassRUI",
                        payload: {
                          section: "datiAzienda",
                          data: { sezioneRUI: e.target.value },
                        },
                      });
                    }}
                  >
                    {sezioneCodiciRUI.map((el) => (
                      <MenuItem key={el.value} value={el.value}>
                        {el.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.datiAzienda.sezioneRUI && (
                    <FormHelperText>
                      {errors.datiAzienda.sezioneRUI}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Codice RUI"
                  fullWidth
                  value={formState.datiAzienda.ivassRUI.codiceRUI}
                  id="codice-rui-Societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_ivassRUI",
                      payload: {
                        section: "datiAzienda",
                        data: { codiceRUI: e.target.value },
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiAzienda.codiceRUI)}
                  helperText={errors.datiAzienda.codiceRUI}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <FormControl fullWidth required>
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    renderInput={(props) => (
                      <TextField
                        {...props}
                        required
                        error={Boolean(errors.datiAzienda.dataIscrizioneRUI)}
                        helperText={errors.datiAzienda.dataIscrizioneRUI}
                      />
                    )}
                    label="Data Iscrizione"
                    name="Data_Iscrizione"
                    id="Data_Iscrizione"
                    value={
                      formState.datiAzienda.ivassRUI.dataIscrizioneRUI === ""
                        ? null
                        : dayjs(
                            formState.datiAzienda.ivassRUI.dataIscrizioneRUI,
                            "DD/MM/YYYY"
                          )
                            .utc()
                            .toISOString()
                    }
                    onChange={(e) => {
                      const value = dayjs(e).format("DD/MM/YYYY");
                      dispatch({
                        type: "set_ivassRUI",
                        payload: {
                          section: "datiAzienda",
                          data: { dataIscrizioneRUI: value },
                        },
                      });
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
      <Card variant="outlined" sx={{ mt: 4 }}>
        <CardContent>
          <Box>
            <Typography component="h1" variant="h6" gutterBottom mb={4}>
              Dati Responsabile
            </Typography>
            <Grid container spacing={3} wrap="wrap">
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Cognome"
                  fullWidth
                  value={formState.datiResponsabile.cognome}
                  id="cognome-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        cognome: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiResponsabile.cognome)}
                  helperText={errors.datiResponsabile.cognome}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Nome"
                  fullWidth
                  value={formState.datiResponsabile.nome}
                  id="nome-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        nome: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiResponsabile.nome)}
                  helperText={errors.datiResponsabile.nome}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="CF"
                  fullWidth
                  value={formState.datiResponsabile.cf}
                  id="cf-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        cf: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiResponsabile.cf)}
                  helperText={errors.datiResponsabile.cf}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={province}
                  getOptionLabel={(option) => option.nome}
                  value={
                    province.find(
                      (p) => p.sigla === formState.datiResponsabile.provincia
                    ) || null
                  }
                  onChange={(_, newValue) => {
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        provincia: newValue ? newValue.sigla : "",
                        comune: "",
                        cap: "",
                      },
                    });
                    if (newValue) handleComuni(newValue.sigla, "responsabile");
                  }}
                  renderInput={(params) => (
                    <TextField
                      id="provinciaResponsabile"
                      name="provinciaResponsabile"
                      error={Boolean(errors.datiResponsabile.provincia)}
                      helperText={errors.datiAzienda.provincia}
                      {...params}
                      label="Provincia"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={comuniResponsabile}
                  getOptionLabel={(option) => option.comune}
                  value={
                    comuniResponsabile.find(
                      (c) => c.codice === formState.datiResponsabile.comune
                    ) || null
                  }
                  onChange={(_, newValue) => {
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        comune: newValue ? newValue.codice : "",
                        cap: "",
                      },
                    });
                    if (newValue) handleCap(newValue.codice, "responsabile");
                  }}
                  renderInput={(params) => (
                    <TextField
                      id="comuneResponsabile"
                      name="comuneResponsabile"
                      error={Boolean(errors.datiResponsabile.comune)}
                      helperText={errors.datiResponsabile.comune}
                      {...params}
                      label="Comune"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <FormControl
                  size="small"
                  fullWidth
                  margin="none"
                  required
                  error={Boolean(errors.datiResponsabile.cap)}
                >
                  <InputLabel id="capResponsabile-label">CAP</InputLabel>
                  <Select
                    labelId="capResponsabile-label"
                    id="capResponsabile"
                    name="capResponsabile"
                    label="CAP"
                    value={formState.datiResponsabile.cap}
                    MenuProps={MenuProps}
                    onChange={(e) => {
                      dispatch({
                        type: "set_datiResponsabile",
                        payload: {
                          cap: e.target.value,
                        },
                      });
                    }}
                  >
                    {capResponsabile.map((el, i) => (
                      <MenuItem key={i} value={el}>
                        {el}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.datiResponsabile.cap && (
                    <FormHelperText>
                      {errors.datiResponsabile.cap}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item sm={3} xs={12}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={toponomie}
                  getOptionLabel={(option) => option.name}
                  value={
                    toponomie.find(
                      (t) => t.value === formState.datiResponsabile.viacorso
                    ) || null
                  }
                  onChange={(_, newValue) => {
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        viacorso: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(errors.datiResponsabile.viacorso)}
                      helperText={errors.datiResponsabile.viacorso}
                      label="Via, Corso"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Indirizzo"
                  fullWidth
                  value={formState.datiResponsabile.indirizzo}
                  id="indirizzo-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        indirizzo: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiResponsabile.indirizzo)}
                  helperText={errors.datiResponsabile.indirizzo}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Civico"
                  fullWidth
                  value={formState.datiResponsabile.civico}
                  id="civico-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        civico: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiResponsabile.civico)}
                  helperText={errors.datiResponsabile.civico}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Cellulare"
                  fullWidth
                  value={formState.datiResponsabile.cellulare}
                  id="cellulare-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        cellulare: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiResponsabile.cellulare)}
                  helperText={errors.datiResponsabile.cellulare}
                />
              </Grid>
              {/* <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="E-mail"
                  fullWidth
                  value={formState.datiResponsabile.email}
                  id="email-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        email: e.target.value,
                      },
                    })
                  }
                  required
                  error={Boolean(errors.datiResponsabile.email)}
                  helperText={errors.datiResponsabile.email}
                />
              </Grid> */}
            </Grid>
          </Box>
          <Box mt={8}>
            <Typography component="h1" variant="h6" gutterBottom mb={4}>
              Ivass RUI Responsabile
            </Typography>
            <Grid container spacing={3} wrap="wrap">
              <Grid item sm={3} xs={12}>
                <FormControl
                  size="small"
                  fullWidth
                  margin="none"
                  required
                  error={Boolean(errors.datiResponsabile.sezioneRUI)}
                >
                  <InputLabel id="sezioneRUI-label">
                    Sezione Codice RUI
                  </InputLabel>
                  <Select
                    labelId="sezioneRUI-label"
                    id="sezioneRUI"
                    name="sezioneRUI"
                    label="Sezione Codice RUI"
                    value={formState.datiResponsabile.ivassRUI.sezioneRUI}
                    MenuProps={MenuProps}
                    onChange={(e) => {
                      dispatch({
                        type: "set_ivassRUI",
                        payload: {
                          section: "datiResponsabile",
                          data: { sezioneRUI: e.target.value },
                        },
                      });
                    }}
                  >
                    {sezioneCodiciRUI.map((el) => (
                      <MenuItem key={el.value} value={el.value}>
                        {el.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.datiResponsabile.sezioneRUI && (
                    <FormHelperText>
                      {errors.datiResponsabile.sezioneRUI}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  size="small"
                  margin="none"
                  label="Codice RUI"
                  fullWidth
                  value={formState.datiResponsabile.ivassRUI.codiceRUI}
                  id="codiceRUI-societa"
                  onChange={(e) =>
                    dispatch({
                      type: "set_ivassRUI",
                      payload: {
                        section: "datiResponsabile",
                        data: { codiceRUI: e.target.value },
                      },
                    })
                  }
                  error={Boolean(errors.datiResponsabile.codiceRUI)}
                  helperText={errors.datiResponsabile.codiceRUI}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <FormControl fullWidth>
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    renderInput={(props) => (
                      <TextField
                        {...props}
                        required
                        error={Boolean(
                          errors.datiResponsabile.dataIscrizioneRUI
                        )}
                        helperText={errors.datiResponsabile.dataIscrizioneRUI}
                      />
                    )}
                    label="Data Iscrizione "
                    name="Data_Iscrizione"
                    id="Data_Iscrizione"
                    value={
                      formState.datiResponsabile.ivassRUI.dataIscrizioneRUI ===
                      ""
                        ? null
                        : dayjs(
                            formState.datiResponsabile.ivassRUI
                              .dataIscrizioneRUI,
                            "DD/MM/YYYY"
                          )
                            .utc()
                            .toISOString()
                    }
                    onChange={(e) => {
                      const value = dayjs(e).format("DD/MM/YYYY");
                      dispatch({
                        type: "set_ivassRUI",
                        payload: {
                          section: "datiResponsabile",
                          data: { dataIscrizioneRUI: value },
                        },
                      });
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default Societa;
